import { Component, Input} from '@angular/core';


@Component({
  selector: 'app-my-class-list-item',
  templateUrl: 'my-class-list-item.html'
})
export class MyClassListItemComponent {
  @Input() reservation: any;

}



// WEBPACK FOOTER //
// ./src/components/my-class-list-item/my-class-list-item.ts